let Footer = () => {
  return (
    <>
      <footer style={{ display: "flex", justifyContent: "center" }} id="footer">
        <ul className="copyright">
          <li>&copy; 2021 Poetlandia</li>
        </ul>
      </footer>
    </>
  );
};

export default Footer;
